export default [{
        path: "*",
        meta: {
            public: true,
        },
        redirect: {
            path: "/404",
        },
    },
    {
        path: "/404",
        meta: {
            public: true,
        },
        name: "NotFound",
        component: () =>
            import (
                /* webpackChunkName: "routes" */
                `@/views/NotFound.vue`
            ),
    },
    {
        path: "/403",
        meta: {
            public: true,
        },
        name: "AccessDenied",
        component: () =>
            import (
                /* webpackChunkName: "routes" */
                `@/views/Deny.vue`
            ),
    },
    {
        path: "/500",
        meta: {
            public: true,
        },
        name: "ServerError",
        component: () =>
            import (
                /* webpackChunkName: "routes" */
                `@/views/Error.vue`
            ),
    },
    {
        path: "/",
        meta: {},
        name: "Root",
        redirect: {
            name: "Login",
        },
    },
    {
        path: "/login",
        meta: {
            public: true,
        },
        name: "Login",
        component: () =>
            import (
                /* webpackChunkName: "routes" */
                `@/views/Login.vue`
            ),
    },
    {
        path: "/home",
        meta: { breadcrumb: false, public: false },
        name: "Home",
        component: () =>
            import (
                /* webpackChunkName: "routes" */
                `@/views/Home.vue`
            ),
    },
    {
        path: "/rentas",
        meta: { breadcrumb: false },
        name: "Rentas",
        component: () =>
            import (
                /* webpackChunkName: "rentas" */
                `@/views/rentas/Rentas.vue`
            ),
    },
    // {
    //   path: '/rentas/hoja-renta',
    //   meta: { breadcrumb: false },
    //   name: 'HojaRenta',
    //   component: () => import(
    //     /* webpackChunkName: "rentas" */
    //     `@/views/rentas/FormRenta.vue`
    //   )
    // },
    {
        path: "/ventas",
        meta: { breadcrumb: false },
        name: "Ventas",
        component: () =>
            import (
                /* webpackChunkName: "ventas" */
                `@/views/ventas/Ventas.vue`
            ),
    },
    {
        path: "/cortes",
        meta: { breadcrumb: false },
        name: "Cortes",
        component: () =>
            import (
                /* webpackChunkName: "ventas" */
                `@/views/corte-caja/Cortes.vue`
            ),
    },
    {
        path: "/ventas/punto-venta",
        meta: { breadcrumb: false },
        name: "PuntoVenta",
        component: () =>
            import (
                /* webpackChunkName: "punto-venta" */
                `@/views/ventas/FormVenta.vue`
            ),
    },
    {
        path: "/producto/precios",
        meta: { breadcrumb: false },
        name: "PreciosProductos",
        component: () =>
            import (
                /* webpackChunkName: "precios-productos" */
                `@/views/producto-catalogo/PreciosProductos.vue`
            ),
    },
    {
        path: "/producto/inventarios",
        meta: { breadcrumb: false },
        name: "InventariosProductos",
        component: () =>
            import (
                /* webpackChunkName: "precios-productos" */
                `@/views/producto-inventario/InventariosProductos.vue`
            ),
    },
    {
        path: "/producto/existencias",
        meta: { breadcrumb: false },
        name: "ExistenciasProductos",
        component: () =>
            import (
                /* webpackChunkName: "precios-productos" */
                `@/views/producto-inventario/ExistenciasProductos.vue`
            ),
    },
    {
        path: "/sucursales",
        meta: { breadcrumb: false },
        name: "Sucursales",
        component: () =>
            import (
                /* webpackChunkName: "sucursales" */
                `@/views/sucursales/Sucursales.vue`
            ),
    },
    {
        path: "/clientes",
        meta: { breadcrumb: false },
        name: "Clientes",
        component: () =>
            import (
                /* webpackChunkName: "sucursales" */
                `@/views/clientes/Clientes.vue`
            ),
    },
    {
        path: "/productos",
        meta: { breadcrumb: true },
        name: "Productos",
        component: () =>
            import (
                /* webpackChunkName: "productos" */
                `@/views/productos/Productos.vue`
            ),
    },
    {
        path: "/conjunto",
        meta: { breadcrumb: true },
        name: "Conjuntos",
        component: () =>
            import (
                /* webpackChunkName: "productos" */
                `@/views/conjunto/Conjuntos.vue`
            ),
    },
    {
        path: "/usuarios",
        meta: { breadcrumb: true },
        name: "Usuarios",
        component: () =>
            import (
                /* webpackChunkName: "productos" */
                `@/views/usuarios/Usuarios.vue`
            ),
    },
    {
        path: "/parametros-empresa",
        meta: { breadcrumb: true },
        name: "ParametrosEmpresa",
        component: () =>
            import (
                /* webpackChunkName: "parametros-empresa" */
                `@/views/parametros-empresa/FormParametrosEmpresa.vue`
            ),
    },
    {
        path: "/otros-catalogos/colores-producto",
        meta: { breadcrumb: false },
        name: "Colores",
        component: () =>
            import (
                /* webpackChunkName: "otros-catalogos" */
                `@/views/otros-catalogos/colores-producto/Colores.vue`
            ),
    },
    {
        path: "/otros-catalogos/tipos-producto",
        meta: { breadcrumb: false },
        name: "TiposProducto",
        component: () =>
            import (
                /* webpackChunkName: "otros-catalogos" */
                `@/views/otros-catalogos/tipos-producto/TiposProducto.vue`
            ),
    },
    {
        path: "/otros-catalogos/lineas-producto",
        meta: { breadcrumb: false },
        name: "LineasProducto",
        component: () =>
            import (
                /* webpackChunkName: "otros-catalogos" */
                `@/views/otros-catalogos/lineas-producto/LineasProducto.vue`
            ),
    },
    {
        path: "/otros-catalogos/tallas-producto",
        meta: { breadcrumb: false },
        name: "Tallas",
        component: () =>
            import (
                /* webpackChunkName: "otros-catalogos" */
                `@/views/otros-catalogos/tallas-producto/Tallas.vue`
            ),
    },
    {
        path: "/otros-catalogos/marcas-producto",
        meta: { breadcrumb: true },
        name: "Marcas",
        component: () =>
            import (
                /* webpackChunkName: "otros-catalogos" */
                `@/views/otros-catalogos/marcas-producto/Marcas.vue`
            ),
    },
    {
        path: "/public-login",
        meta: {
            public: true,
        },
        name: "PublicLogin",
        component: () =>
            import (
                /* webpackChunkName: "public" */
                `@/views/public/PublicLogin.vue`
            ),
    },
    {
        path: "/public-home",
        meta: {
            public: true,
        },
        name: "PublicHome",
        component: () =>
            import (
                /* webpackChunkName: "public" */
                `@/views/public/PublicHome.vue`
            ),
    },
    {
        path: "/public-form-cliente",
        meta: {
            public: true
        },
        name: "PublicFormCliente",
        params: true,
        component: () =>
            import (
                /* webpackChunkName: "public" */
                `@/views/public/FormClientePublic.vue`
            ),
    }
];